import { Component, OnInit } from '@angular/core';
import { FIRST_B2B_NAV, SECOUND_B2B_NAV, THIRD_B2B_NAV } from 'src/app/constants/navigation';
import { CorporateService } from 'src/app/services';

@Component({
  selector: 'app-corporate-footer',
  templateUrl: './corporate-footer.component.html',
  styleUrls: ['./corporate-footer.component.scss']
})
export class CorporateFooterComponent implements OnInit {
  currentYear = new Date().getFullYear();
  companies = this.COPT.companies;
  filteredCompanies: any[] = [];
  companyList = null;
  FIRST_B2B_ = FIRST_B2B_NAV;
  SECOUND_B2B_ = SECOUND_B2B_NAV;
  THIRD_B2B_ = THIRD_B2B_NAV;

  logoCompy = [
    { name: 'iat', logo: '../../assets/b2b/iat.png' },
    { name: 'arc', logo: '../../assets/b2b/arc.png' },
    { name: 'pata', logo: '../../assets/b2b/pata.svg' },
    { name: 'taf', logo: '../../assets/b2b/taf.png' },
    { name: 'tai', logo: '../../assets/b2b/tai.png' },
    { name: 'pat', logo: '../../assets/b2b/pat.png' },
    { name: 'iatomem', logo: '../../assets/b2b/iatomem.png' },
    { name: 'ufta', logo: '../../assets/b2b/ufta.png' },
    { name: 'ministry', logo: '../../assets/b2b/ministry.png' },
  ]
  constructor(private COPT: CorporateService) { }

  ngOnInit(): void {
    this.companyList = this.companies?.find(c => c.active && c.country_key === 'india');
  }

}
